import { GET_ALL_SEGMENTS, SHOW_ERRORS_API } from "../../types";

const SegmentsReducer = (state, action) => {
  switch (action.type) {
    case GET_ALL_SEGMENTS:
      return {
        ...state,
        segments: action.payload,
        success: false,
        ErrorsApi: [],
      };
    case SHOW_ERRORS_API:
      return {
        ...state,
        ErrorsApi: action.payload,
      };
    default:
      return state;
  }
};

export default SegmentsReducer;

